import { BehaviorSubject } from 'rxjs';
import { IMenu } from './shared/models/menu';

export const menu$ = new BehaviorSubject<IMenu[]>([
  {
    route: "dashboard",
    name: "Dashboard",
    type: "link",
    icon: "dashboard",
    roles: ['Oregon Well']
  },
  {
    route: "well/dashboard",
    name: "Wells / Samples",
    type: "sub",
    icon: "water_drop",
    roles: ['Oregon Well'],
    children: [
      {
        route: "well/search",
        name: "Search",
        icon: "search",
        type: "link",
        roles: ['Oregon Well']
      },
      {
        route: "well/add",
        name: "Add Well",
        icon: "add",
        type: "link",
        roles: ['Oregon Well'],
        excludeReadOnly: true
      }
    ],
  },
  {
    route: "vouchers/search",
    name: "Vouchers",
    type: "sub",
    icon: "card_membership",
    roles: ['Oregon Well'],
    children: [
      {
        route: "vouchers/search",
        name: "Search",
        icon: "search",
        type: "link",
        roles: ['Oregon Well']
      },
      {
        route: "vouchers/import",
        name: "Import Applications",
        icon: "cloud_download",
        type: "link",
        roles: ['Oregon Well'],
        excludeReadOnly: true
      },
      {
        route: "vouchers/add",
        name: "Add Application",
        icon: "add",
        type: "link",
        roles: ['Oregon Well'],
        excludeReadOnly: true
      },
      {
        route: "vouchers/upload",
        name: "Upload Test Results",
        icon: "file_upload",
        type: "link",
        roles: ['Oregon Well'],
        excludeReadOnly: true
      }
    ],
  },
  {
    route: "households/search",
    name: "Households/Units",
    type: "sub",
    icon: "house",
    roles: ['Oregon Well'],
    children: [
      {
        route: "households/search",
        name: "Search",
        icon: "search",
        type: "link",
        roles: ['Oregon Well']
      },
      {
        route: "households/add",
        name: "Add Household",
        icon: "add",
        type: "link",
        roles: ['Oregon Well'],
        excludeReadOnly: true
      },
      {
        route: "housingunit/add",
        name: "Add Housing Unit",
        icon: "add",
        type: "link",
        roles: ['Oregon Well'],
        excludeReadOnly: true
      },
    ]
  },
  {
    route: "vouchers/reports",
    name: "Reports",
    type: "link",
    icon: "bar_chart",
    roles: ['Oregon Well'],
    excludeReadOnly: true
  },
  {
    route: "retests/search",
    name: "Retest Schedule",
    type: "sub",
    icon: "restart_alt",
    roles: ['Oregon Well'],
    excludeReadOnly: true,
    children: [
      {
        route: "retests/search",
        name: "Search",
        icon: "search",
        type: "link",
        roles: ['Oregon Well'],
        excludeReadOnly: true
      },
      {
        route: "retests/chain-of-custody",
        name: "Chain of Custody",
        icon: "link",
        type: "link",
        roles: ['Oregon Well'],
        excludeReadOnly: true
      }
    ],
  },
  {
    route: "labs",
    name: "Organizations",
    type: "link",
    icon: "business",
    roles: ['Oregon Well'],
    excludeReadOnly: true
  },
  {
    route: "invoices/search",
    name: "Invoices",
    type: "sub",
    icon: "receipt",
    roles: ['Oregon Well'],
    excludeReadOnly: true,
    children: [
      {
        route: "invoices/search",
        name: "Search",
        icon: "search",
        type: "link",
        roles: ['Oregon Well'],
        excludeReadOnly: true
      },
      {
        route: "invoices/add",
        name: "Add Invoice",
        icon: "add",
        type: "link",
        roles: ['Oregon Well'],
        excludeReadOnly: true
      }
    ],
  },
  {
    route: "user-management",
    name: "Admin",
    type: "sub",
    icon: "settings",
    roles: ['Admin'],
    excludeReadOnly: true,
    children: [
      {
        route: "user-management",
        name: "User Management",
        icon: "manage_accounts",
        type: "link",
        roles: ['Admin'],
        excludeReadOnly: true
      },
      {
        route: "partner-management",
        name: "Partner Management",
        icon: "handshake",
        type: "link",
        roles: ['Admin'],
        excludeReadOnly: true
      }
    ]
  }
]);
